export const environment = {
  name: 'live',
  production: true,

  environmentBaseUrl: '',

  appBaseHref: '/ux',
  apiBaseUrl: '/uxapi/v1',

  // Injected at UX build time (via pre-build.js)
  agGridLicenseKey: 'Using_this_{AG_Grid}_Enterprise_key_{AG-080731}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Environmental_Science_Associates}_is_granted_a_{Multiple_Applications}_Developer_License_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{31_August_2026}____[v3]_[01]_MTc4ODEzMDgwMDAwMA==c325a82b95593f94ba40c3c12b593f03',
  gojsLicenseKey: '2bf845e7bb3758c512a50e214c3e6ef919a07567c98118e21d5613a4ed096d4721cdee7a06d282c980fd4df4127990db88c53a2fc44e5529f737d68c43e282aabb6571b015084286a20674ca9dfe28a7ac7821f590b375f1de7ddca5efbad39a09b8f5d41a9a0fa93971',
  googleAnalyticsKey: 'G-28FKB8KPP7',
  recaptchaKey: '6Lc8dksUAAAAACr__RNtoSlEYrQ6meIUudBKuMOr',

  // Injected at container runtime (via entrypoint script from Terraform outputs)
  awsRegion: '{awsRegion}',
  rumAppId: '{rumAppId}',
  rumIdentityPoolId: '{rumIdentityPoolId}',
  rumSessionSampleRate: '{rumSessionSampleRate}',

  featureFlags: {
    newWidget: true,
    smartGuide: true,
    tocGuide: true,
    subscriptionNudgeBanner: true,
    manualOrganizationCreation: true,
  },
};
